import { AppRootState } from "./appStore"
import { SettingId } from "@fusion-advantage/backcompat"
import { DateTime } from "luxon"

// not memoized: this always needs to run live against the current time
export const selectSessionIsNotExpired = (state: AppRootState): boolean => {
	const now = DateTime.now().toMillis()
	const sessionExpiredAt = state.app.sessionExpiredAt
	if(sessionExpiredAt && sessionExpiredAt > now) {
		return true
	}
	const bearerToken = state.app[SettingId.BearerToken]
	if(bearerToken && bearerToken.expiredAt > now) {
		return true
	}
	return false
}

// not memoized: this always needs to run live against the current time
export const selectSessionIsExpired = (state: AppRootState): boolean => {
	const now = DateTime.now().toMillis()
	const sessionExpiredAt = state.app.sessionExpiredAt
	if(sessionExpiredAt && sessionExpiredAt < now) {
		return true
	}
	const bearerToken = state.app[SettingId.BearerToken]
	if(bearerToken && bearerToken.expiredAt < now) {
		return true
	}
	return false
}
